import * as actionTypes from '../actions/actionTypes';

export default function countryInfoReducer(state = [], action) {
  switch(action.type){
    case actionTypes.SET_COUNTRY_INFO: {
      return action.countryInfo;
    }
    case actionTypes.RESET_COUNTRYINFO_DROPDOWN: {
      return [];
    }
    default: {
      return state;
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/createAcase/reducers/countryInfoReducer.js